import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { hideModal } from 'state/actions';
import { MODAL } from 'config/constants';
import { HvModal } from 'components';
import { ModalStepper } from '../components';

function VirtualServiceModal() {
  const intl = useIntl();
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(hideModal(MODAL.VIRTUAL_STAGING));
  };

  return (
    <HvModal
      title={intl.formatMessage({ id: 'deliver.photos.virtualServiceModal.title' })}
      headerImage='virtualStagingBg'
      onClose={onClose}
    >
      <ModalStepper onClose={onClose} />
    </HvModal>
  );
}
export default VirtualServiceModal;
